const programContactEmails = {
  'Backpack Buddy': 'backpackbuddy@houstonfoodbank.org',
  'Kids Cafe': 'kidscafe@houstonfoodbank.org',
  'Partner Services': 'info@houstonfoodbank.org',
  'School Market': 'schoolprograms@houstonfoodbank.org',
  'Teachers Aid': 'teachersaid@houstonfoodbank.org',
};

export default programContactEmails;
